import { render, staticRenderFns } from "./chat-user.vue?vue&type=template&id=063c5295&scoped=true&"
import script from "./chat-user.vue?vue&type=script&lang=js&"
export * from "./chat-user.vue?vue&type=script&lang=js&"
import style0 from "./chat-user.vue?vue&type=style&index=0&id=063c5295&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c5295",
  null
  
)

export default component.exports